import { Component, DestroyRef, EventEmitter, Input, Output, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { switchMap } from 'rxjs';
import { SalesInsightsActivityService } from '../../services/sales-insights-activity.service';
import { SalesInsightsDashboardState } from '../../services/sales-insights-dashboard-state.service';
import { salesInsightsGoalTypeCode } from '../../utils/sales-insights-activity-types';

export interface SalesInsightsBooked {
  customerId: string | null;
  goalId: string | null;
}

@Component({
  selector: 'lib-sales-insights-book-activity',
  standalone: false,
  templateUrl: './sales-insights-book-activity.component.html',
  styleUrl: './sales-insights-book-activity.component.scss'
})
export class SalesInsightsBookActivityComponent {
  @Input() customerId?: string | null;
  @Input() date?: Date | null;
  // A goal's booking starts on the goal's own activity type, or on its only type.
  @Input() goalId?: string | null;
  @Input() goalTypes?: string[] | null;
  @Input() activityType?: string | null;
  @Input() labelKey = 'SALES_INSIGHTS_BOOK_ACTIVITY';
  @Input() icon = 'fa-regular fa-calendar-plus';
  @Input() buttonClass = '';
  @Output() booked = new EventEmitter<SalesInsightsBooked>();

  protected activityService = inject(SalesInsightsActivityService);
  protected dashboardState = inject(SalesInsightsDashboardState);
  private destroyRef = inject(DestroyRef);

  busy = false;

  book(): void {
    if (this.busy) {
      return;
    }
    this.busy = true;
    const goalId = this.goalId || null;
    this.activityService
      .loadTypes()
      .pipe(
        switchMap(types =>
          this.activityService.book(
            this.customerId,
            this.date,
            this.activityType || salesInsightsGoalTypeCode(types, goalId, this.goalTypes)
          )
        ),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe({
        next: saved => {
          this.busy = false;
          if (!saved) {
            return;
          }
          this.dashboardState.notifyChanged('activities');
          this.dashboardState.notifyChanged('goals');
          this.booked.emit({ customerId: this.customerId || null, goalId });
        },
        error: () => (this.busy = false)
      });
  }
}
